




































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import NumberPads from '@/components/Money/numberPads.vue';
import Card from '@/components/Card.vue';
import Button from '@/components/Button.vue';
import FormItem from '@/components/Money/FormItem.vue';

@Component({
    components: {FormItem, Button, Card, NumberPads}
})
export default class extends Vue {
    @Prop() RecordToggle?: boolean;
    @Prop() dataIncome: Tag[] | undefined;
    @Prop() dataExpense: Tag[] | undefined;
    record: RecordItem = {
        notes: '',
        tags: [],
        type: '-',
        amount: 0,
        amountToString: '0'

    };

    handleClick() {

        this.$emit('update:RecordToggle', false);
    }

    setType() {
        if (this.record.type !== '+') {
            this.record.type = '+';
        } else {
            this.record.type = '-';
        }
    }

    submit() {
        if(this.record.tags.length===0){
            alert('请至少选择一个标签');
            return
        }
        this.record.amount = parseFloat(this.record.amountToString as string) | 0;
        this.$store.commit('createRecord',this.record);
        this.$emit('update:RecordToggle', false);
        this.record = {
            notes: '',
            tags: [],
            type: '-',
            amount: 0,
            amountToString: '0'
        };
    }

    handleTag(tag: Tag) {
        const index = this.record.tags.indexOf(tag);
        if (this.record.tags.length == 0) {
            this.record.tags.push(tag);
        } else if (this.record.tags.indexOf(tag) >= 0) {
            this.record.tags.splice(index, 1);
        } else {
            this.record.tags = [];
            this.record.tags.push(tag);
        }
    }


}
